<template>
  <div id="app">
    <navigation></navigation>
    <router-view></router-view>
  </div>
</template>

<script>
import Navigation from './components/Navigation'
export default {
  name: 'app',
  components: {Navigation}
}
</script>



// WEBPACK FOOTER //
// App.vue?358979aa